import {
  EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE,
  EDITING_DOCUMENTS_LIST_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { EditingDocumentsAction } from '@app/store/editingDocuments/actions';

type EditingDocumentsMemberIdState = string | null;

const initialState: EditingDocumentsMemberIdState = null;
export default function reducer(
  state: EditingDocumentsMemberIdState = initialState,
  action: EditingDocumentsAction
) {
  switch (action.type) {
    case EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE:
      return initialState;
    case EDITING_DOCUMENTS_LIST_FETCH_SUCCESS:
      return action.payload.memberId;
    default:
      return state;
  }
}
